module.exports = __webpack_public_path__ + "img/icon-04-exercises.bcb2cf92.svg";